<template>
  <div>
    <booking-search />
    <booking-results v-if="resultsAvailable" />
  </div>
</template>

<script>
import BookingResults from './BookingResults'
import BookingSearch from './BookingSearch'

export default {
    name: 'BookingSearchPage',
    components: {
        'booking-results': BookingResults,
        'booking-search': BookingSearch
    },
    computed: {
        resultsAvailable: {
            get () {
                const results = this.$store.state.booking.bookingResults
                return results.length > 0
            }
        }
    }
}
</script>
